import React, { Component } from "react";

//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import Aporte from "./AporteSocio";
import Solidaridad from "./SolidaridadSocio";
import AHVista from "./AHVista";
import AhorroProgramado from "./AhorroProgramado";
import Rueda from "./RuedaSocio";
import PlazoFijo from "./PlazoFijo";
import Tarjetas from "./TarjetaCredito";
import Prestamos from "./Prestamo";
import ResumenServices from "../../../services/resumenGeneral/resumenSocioService"
import PrestamoPreaprobadoServices from "../../../services/solicitudes/PrestamoPreaprobadoService"
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import { formatoSeparadorMilesValue, anhoActual, dateFormat, validarNull, formatoSeparadorMilesValueDollar } from '../../generico/utils/FormatoInput'
import { separadorPuntoMiles } from "../../generico/utils/FormatoInput";
import authService from "../../../services/login/auth.service";
import SolicitudesPrestamo from "./SolicitudesPrestamos";
import history from "../../pages/login/history";
import AvisoPrestamo from "../../generico/Prestamo/AvisoPrestamo";
import DimoService from "../../../services/resumenGeneral/dimoService";
import TarjetaService from "../../../services/pagos/TarjetaService";
import PrestamoPreaprobadoBanner from "./PrestamoPreaprobadoBanner";
import PrestamoInmediatoBanner from "./PrestamoInmediatoBanner";
import ConfigService from "../../../services/configuracion/ConfigService";
import PopupInscripcionAsamblea from "./PopupInscripcionAsamblea";
import Subsidios from "./Subsidios"
import { Link } from "react-router-dom";
import AvisoSocio from "./AvisoSocio";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPiggyBank, faCircleDollarToSlot, faHandHoldingDollar, faCircleDot, faCoins, faHandshake, faMoneyCheckDollar, faClipboardCheck, faDownload, faArrowRight, faHand, faCross, faDove, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import { obtenerDatosOficialCuenta } from "../../../services/administracion/OficialCuentaService";
import { Sepelio } from "./Sepelio";
import PagoSepelioService from "../../../services/pagos/PagoSepelioService";
import { ModalPinTransaccional } from "../../generico/ModalPinTransaccional";
import { ModificacionFechaVencPrestamo } from './ModificacionFechaVencPrestamo';


const ToastMessage = ({ titulo, mensaje, url }) => {
    console.log("mensaje", titulo);
    return (
        <>

            {mensaje}
            <br /><br />
            {url && <Link className="linker" to={url}>Actualizar</Link>}
        </>

    )

}

const notify = (msg) => toast.success(<ToastMessage mensaje={msg} url={"/datosPersonales"} />, { autoClose: 30000, theme: "dark", className: "toast-inicio" });

const AuxNavItem = ({ children, name, onClick, href }) => {

    const handleClick = () => {
        onClick();
    }


    let prevPath = ConfigService.getPreviousPathByName(name);

    let isFirst = prevPath === null ? true : false;

    /**
     * @description contiene las clases a asignar, segun el path habilitado
     */
    let className = isFirst
        ? "nav-link active"
        : prevPath === null
            ? "nav-link active"
            : "nav-link"


    return (
        ConfigService.getPathByName(name) !== null
            ?
            <li className="nav-item">
                <a className={className}
                    href={href}
                    data-toggle="tab"
                    onClick={() => handleClick()}
                >
                    {children}
                </a>
            </li>
            : null
    )
}



const TabPane = ({ children, id, name }) => {

    let prevPath = ConfigService.getPreviousPathByName(name);

    let isFirst = prevPath === null ? true : false;

    /**
     * @description contiene las clases a asignar, segun el path habilitado
     */
    let className = isFirst
        ? "tab-pane table-responsive active"
        : prevPath === null
            ? "tab-pane table-responsive active"
            : "tab-pane table-responsive"

    return (
        ConfigService.getPathByName(name) !== null
            ?
            <div className={className}
                id={id}
            >
                {children}
            </div>
            : null
    )
}

export default class ResumenGeneralSocio extends Component {
    constructor(props) {
        super(props);
        this.refAporte = React.createRef();
        this.refSolidaridad = React.createRef();
        this.refAHVista = React.createRef();
        this.refAhorroProgramado = React.createRef();
        this.refRueda = React.createRef();
        this.refPlazoFijo = React.createRef();
        this.refCotizacion = React.createRef();
        this.refTC = React.createRef();
        this.refPrestamos = React.createRef();
        this.refSolPrestamo = React.createRef();
        this.refModifFechaVencPrestamo = React.createRef();
        this.refPreaprobado = React.createRef();
        this.refSubsidios = React.createRef();
        this.state = this.getInitialState();

        this.openAhorro = false;
        this.openPrestamo = false;
        this.openTarjeta = false;
        this.openObligacion = false;
        this.openSubsidio = false;
        this.socioEsCalificado = false;

        this.mostrarPreaprobado = false;

        this.montoMaxDisponible = false;

    }

    componentDidMount() {
        sessionStorage.removeItem("AH");
        sessionStorage.removeItem("tipo");
        sessionStorage.removeItem("resumen");
        sessionStorage.removeItem("deuda");
        this.obtenerAviso();
        //this.cargarCotizaciones();
        this.getAvisoAlSocio();
        this.PrestamoPreaprobadoBanner();
        //this.cargarCotizaciones1();
        // this.metaUser();
        //this.cargarPromoTarjeta();
        try {
            var socio = JSON.parse(sessionStorage.getItem("socio"));
            this.setState({ socio });
        } catch (error) {
            console.log(error);
        }

    }

    prestamoInmediato = () => {
        //console.log(row)

        history.push("prestamoInmediato");
        window.location.reload();
    }


    lectorQr() {
        var socio = sessionStorage.getItem("socio.username");

    }

    notifiPromo = (titulo, mensaje, funcion) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            funcion();
                            Popup.close();
                        },
                    },
                ],
                left: [
                    {
                        text: "Cancelar",
                        className: "",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });

    notifiPopup2 = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Cerrar",
                        className: "secundary",
                        action: function () {
                            sessionStorage.setItem("apagarAlertaDatos", true);
                            Popup.close();
                        },
                    },
                    {
                        text: "Continuar",
                        className: "success",
                        action: function () {
                            //history.push("/datosPersonales");
                            history.push(ConfigService.getPathByName("datosPersonales")?.url);
                            window.location.reload();
                            Popup.close();
                        },
                    },
                ],
            },
        });



    cargarPromoTarjeta = () => {

        trackPromise(
            ResumenServices.getPromoTarjeta("WEB")
                .then((response) => {

                    let newState = { ...this.state };
                    //console.log("response tarjetas");
                    //console.log(response);

                    //console.log(JSON.parse(response));

                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);

                    if (jsonData.codigoRetorno === "0") {

                        let resultadoOriginal, resultadoDisponible = null;

                        if (jsonData.promoTarjeta !== null) {

                            resultadoOriginal = jsonData.promoTarjeta;

                            resultadoDisponible = {
                                idLinea: jsonData.promoTarjeta.numeroSocioLineaTarj,
                                montoLinea: formatoSeparadorMilesValue(jsonData.promoTarjeta.nuevaLinea),
                                saldo: formatoSeparadorMilesValue(jsonData.promoTarjeta.disponible),
                                fecha: dateFormat(jsonData.promoTarjeta.fecha),
                                fechaVencimiento: dateFormat(jsonData.promoTarjeta.fechaVencimiento),
                                funcionarioVendedor: jsonData.promoTarjeta.usuarioVendedorNombre
                            };


                            newState = {
                                ...newState,
                                lineaTarjeta: resultadoDisponible,
                                lineaTarjetaOriginal: resultadoOriginal
                            }

                        }

                        this.setState(newState);

                    }

                }

                ).catch(function (error) {
                    //console.log(error)
                    authService.logout();
                })
        );

    }
    // metaUser() {
    //     var socio = authService.getSocio();
    //     window.ineum('user', socio.numeroSocio)
    //     console.log("usuario", window.ineum('user', socio.numeroSocio))
    // }
    getAvisoAlSocio() {
        var socio = sessionStorage.getItem("socio");
        socio = JSON.parse(socio);
        if (socio === null) {
            socio = authService.getSocio();
        } else {
            if (socio.mostrar === "S" && history.location.pathname === "/resumenGeneralSocio") {
                if (sessionStorage.getItem("apagarAlertaDatos") !== "true") {
                    Popup.queue(
                        this.notifiPopup2("Aviso al Socio", "POR MOTIVOS DE SEGURIDAD, SOLICITAMOS QUE MANTENGA ACTUALIZADOS SUS DATOS PERSONALES.")
                    );
                }
            }
        }
    }


    getInitialState = () => ({
        cotizaciones: [],
        aportes: [],
        detalleAporte: [],
        solidaridad: [],
        detalleSolidaridad: [],
        detallePagareSepelio: [],
        ahorros: [],
        ahorroProgramado: [],
        ruedas: [],
        plazoFijo: [],
        tarjetas: [],
        mensajeSinTarjetas: "",
        prestamos: [],
        subsidios: [],
        prestamosCuotaModificable : [],
        solicitudPrestamos: [],
        prestamoPreaprobado: [],
        prestamoInmediato: [],
        lineaTarjetaDisponible: null,
        lineaTarjeta: {},
        lineaTarjetaOriginal: {},
        datosOficialCuenta: null,
        aviso: {},
        mostrarPrestamoInmediato: false,
        autorizador:'N'
    })

    solicitarPrecalificado = () => {
        Popup.queue(this.notifiPromo("Confirmación", "Está seguro que desea continuar con la solicitud?", this.realizarSolicitudPrecalificado.bind(this)));
        return;
    }

    realizarSolicitudPrecalificado = () => {
        trackPromise(
            TarjetaService.solicitarPrecalificado(this.state.lineaTarjetaOriginal)
                .then((response) => {
                    if (response.data.codigoRetorno === "0") {
                        this.setState({ lineaTarjeta: [], lineaTarjetaOriginal: [] });
                        Popup.queue(this.notifiPopup("Info", response.data.mensajeRetorno));
                    } else {
                        let msg = response.data.mensajeRetorno ? response.data.mensajeRetorno : "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";
                        Popup.queue(this.notifiPopup("Error", msg));
                    }

                })
                .catch((error) => {
                    console.error(error);
                    let msg = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";
                    Popup.queue(this.notifiPopup("Info", msg));
                })
        )
    }

    cargarCotizaciones = () => {

        var cotizacion = [];

        trackPromise(
            ResumenServices.getCotizaciones("WEB")
                .then((response) => {

                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    //console.log(jsonData)
                    if (jsonData.codigo === "0") {

                        for (var i = 0; i < jsonData.resultados.length; i++) {
                            cotizacion.push({
                                moneda: jsonData.resultados[i].moneda,
                                descripcion: jsonData.resultados[i].descripcion,
                                compra: jsonData.resultados[i].compra,
                                venta: jsonData.resultados[i].venta,
                            });
                        }

                        this.setState({ cotizaciones: cotizacion });
                    }
                    else {

                        if (jsonData.codigo > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            return;
                        }
                    }
                }

                ).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                })
        );
        return cotizacion;
    }

    cargarAporte = () => {

        var aportes = [];
        var cuotas = [];

        if (this.openObligacion == true) {
            this.openObligacion = false;
            return;
        }

        this.openObligacion = true;

        trackPromise(

            ResumenServices.getAporteSocio("WEB", anhoActual())
                .then((response) => {

                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    //console.log(jsonData)
                    if (jsonData.codigoRetorno === "0") {
                        aportes.push({
                            integrado: formatoSeparadorMilesValue(jsonData.resultado.integrado), obligacionAnho: formatoSeparadorMilesValue(jsonData.resultado.obligacionAnho),
                            obligacionFecha: formatoSeparadorMilesValue(jsonData.resultado.obligacionFecha),
                            obligacionMes: formatoSeparadorMilesValue(jsonData.resultado.obligacionMes),

                        });

                        for (var i = 0; i < jsonData.resultadoDetalle.length; i++) {
                            cuotas.push({
                                numeroCuota: jsonData.resultadoDetalle[i].numeroCuota,
                                importeDebito: formatoSeparadorMilesValue(jsonData.resultadoDetalle[i].importeDebito),
                                importeCredito: formatoSeparadorMilesValue(jsonData.resultadoDetalle[i].importeCredito),
                                fechaVencimiento: jsonData.resultadoDetalle[i].fechaVencimiento,
                                fechaUltimoPago: jsonData.resultadoDetalle[i].fechaUltimoPago,
                                estado: jsonData.resultadoDetalle[i].estado,
                            });
                        }
                        //console.log(aportes)
                        this.setState({ aportes: aportes, detalleAporte: cuotas });
                    }
                    else {
                        if (jsonData.codigoRetorno > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
                            return;
                        }
                    }
                })
                .catch(function (error) {
                    console.log({ error })
                    authService.logout()
                })
        );
        return aportes;
    }

    cargarPagareSepelio = () => {

        let { detallePagareSepelio } = this.state;

        trackPromise(
            PagoSepelioService.getPagareSepelio().then((response) => {
                // console.trace(response);

                let { codigoRetorno, mensajeRetorno, datos } = response.data;

                if (codigoRetorno === "0") {
                    detallePagareSepelio = datos.map(dato => ({ ...dato, disabled: dato.nombreSubsidiado === null }));
                    this.setState({ detallePagareSepelio });
                } else {
                    Popup.queue(this.notifiPopup("Info", mensajeRetorno));
                    return;
                }

            })
        )

    }

    cargarSolidaridad = () => {

        var solidaridad = [];
        var cuotas = [];
        trackPromise(
            ResumenServices.getSolidaridadSocio("WEB", anhoActual())
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    // console.log(response)
                    if (jsonData.codigoRetorno === "0") {
                        solidaridad.push({
                            integrado: formatoSeparadorMilesValue(jsonData.resultado.integrado), obligacionAnho: formatoSeparadorMilesValue(jsonData.resultado.obligacionAnho),
                            obligacionFecha: formatoSeparadorMilesValue(jsonData.resultado.obligacionFecha),
                            obligacionMes: formatoSeparadorMilesValue(jsonData.resultado.obligacionMes),

                        });

                        for (var i = 0; i < jsonData.resultadoDetalle.length; i++) {
                            cuotas.push({
                                numeroCuota: jsonData.resultadoDetalle[i].numeroCuota,
                                importeDebito: formatoSeparadorMilesValue(jsonData.resultadoDetalle[i].importeDebito),
                                importeCredito: formatoSeparadorMilesValue(jsonData.resultadoDetalle[i].importeCredito),
                                fechaVencimiento: jsonData.resultadoDetalle[i].fechaVencimiento,
                                fechaUltimoPago: jsonData.resultadoDetalle[i].fechaUltimoPago,
                                estado: jsonData.resultadoDetalle[i].estado,
                            });
                        }
                        //console.log(aportes)
                        this.setState({ solidaridad: solidaridad, detalleSolidaridad: cuotas });
                    }
                    else {
                        if (jsonData.codigoRetorno > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
                            return;
                        }
                    }
                }


                ).catch(function (error) {
                    authService.logout()
                    // console.log(error)
                }));
        return solidaridad;
    }

    cargarAHVista = () => {

        var ahVista = [];

        if (this.openAhorro == true) {
            this.openAhorro = false;
            return;
        }
        this.openAhorro = true;
        trackPromise(
            ResumenServices.getAHVistaSocio("WEB")
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);

                    if (jsonData.codigo === "0") {


                        for (var i = 0; i < jsonData.resultados.length; i++) {
                            // console.log("valor de moneda", jsonData.resultados[i].moneda)
                            if (jsonData.resultados[i].moneda === 'U$S') {
                                ahVista.push({
                                    ahorro: jsonData.resultados[i].ahorro,
                                    descripcion: jsonData.resultados[i].descripcion,
                                    moneda: jsonData.resultados[i].moneda,
                                    fechaApertura: jsonData.resultados[i].fechaApertura,
                                    saldoActual: formatoSeparadorMilesValueDollar(jsonData.resultados[i].saldoActual),
                                    saldoRetenido: formatoSeparadorMilesValueDollar(jsonData.resultados[i].saldoRetenido),
                                    disponible: formatoSeparadorMilesValueDollar(jsonData.resultados[i].disponible),
                                    saldoBloqueado: formatoSeparadorMilesValueDollar(jsonData.resultados[i].saldoBloqueado),
                                    saldoGarantia: formatoSeparadorMilesValueDollar(jsonData.resultados[i].saldoGarantia),
                                    saldoCaucionado: formatoSeparadorMilesValueDollar(jsonData.resultados[i].saldoCaucionado),



                                });
                            } else {
                                ahVista.push({
                                    ahorro: jsonData.resultados[i].ahorro,
                                    descripcion: jsonData.resultados[i].descripcion,
                                    moneda: jsonData.resultados[i].moneda,
                                    fechaApertura: jsonData.resultados[i].fechaApertura,
                                    saldoActual: formatoSeparadorMilesValue(jsonData.resultados[i].saldoActual),
                                    saldoRetenido: formatoSeparadorMilesValue(jsonData.resultados[i].saldoRetenido),
                                    disponible: formatoSeparadorMilesValue(jsonData.resultados[i].disponible),
                                    saldoBloqueado: formatoSeparadorMilesValue(jsonData.resultados[i].saldoBloqueado),
                                    saldoGarantia: formatoSeparadorMilesValue(jsonData.resultados[i].saldoGarantia),
                                    saldoCaucionado: formatoSeparadorMilesValue(jsonData.resultados[i].saldoCaucionado),
                                    etiqueta: jsonData.resultados[i]?.etiqueta

                                });
                            }

                        }
                        //console.log(aportes)
                        this.setState({ ahorros: ahVista });
                    }
                    else {
                        if (jsonData.codigo > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            return;
                        }
                    }
                }


                ).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                }));
        //return solidaridad;
    }

    cargarAhorroProgramado = () => {
        var programado = [];
        trackPromise(
            ResumenServices.getAHProgramadoSocio("WEB")
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    //   console.log(response)
                    if (jsonData.codigo === "0") {
                        for (var i = 0; i < jsonData.resultados.length; i++) {
                            programado.push({
                                cuenta: jsonData.resultados[i].cuenta,
                                moneda: jsonData.resultados[i].moneda,
                                cuota: jsonData.resultados[i].cuota,
                                fechaVencimiento: jsonData.resultados[i].fechaVencimiento,
                                saldoTotal: formatoSeparadorMilesValue(jsonData.resultados[i].saldoTotal),
                                pendiente: formatoSeparadorMilesValue(jsonData.resultados[i].pendiente),
                                fechaApertura: jsonData.resultados[i].fechaApertura,
                                plazo: jsonData.resultados[i].plazo,
                                importeCuota: formatoSeparadorMilesValue(jsonData.resultados[i].importeCuota),
                                idModalidad: jsonData.resultados[i].idModalidad
                            });
                        }
                        this.setState({ ahorroProgramado: programado });
                    }
                    else {
                        if (jsonData.codigo > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            return;
                        }
                    }
                }


                ).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                }));
        return programado;
    }

    cargarRuedas = () => {
        var rueda = [];
        trackPromise(
            ResumenServices.getRuedaGiganteSocio("WEB")
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);

                    if (jsonData.codigo === "0") {

                        for (var i = 0; i < jsonData.resultados.length; i++) {
                            rueda.push({
                                cuenta: jsonData.resultados[i].cuenta,
                                grupo: jsonData.resultados[i].grupo,
                                plan: jsonData.resultados[i].plan,
                                contrato: jsonData.resultados[i].contrato,
                                cuota: jsonData.resultados[i].cuotasPagadas + "/" + jsonData.resultados[i].cantidadCuota,
                                fechaVencimiento: jsonData.resultados[i].fechaVencimiento,
                                monto: formatoSeparadorMilesValue(jsonData.resultados[i].monto),
                                depositos: formatoSeparadorMilesValue(jsonData.resultados[i].depositos),
                                ultimoPago: jsonData.resultados[i].ultimoPago,
                                importeCuota: formatoSeparadorMilesValue(jsonData.resultados[i].importeCuota),
                                fechaInscripcion: jsonData.resultados[i].fechaInscripcion
                            });
                        }
                        this.setState({ ruedas: rueda });
                    }
                    else {
                        if (jsonData.codigo > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            return;
                        }
                    }
                }


                ).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                }));
        return rueda;
    }

    cargarPlazoFijo = () => {
        var plazo = [];
        trackPromise(
            ResumenServices.getAHPlazosFijosSocio("WEB")
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    //  console.log(response)
                    if (jsonData.codigo === "0") {

                        for (var i = 0; i < jsonData.resultados.length; i++) {
                            if (jsonData.resultados[i].moneda === 'U$S') {
                                plazo.push({
                                    cuenta: jsonData.resultados[i].cuenta,
                                    descripcion: jsonData.resultados[i].descripcion,
                                    saldoTotal: formatoSeparadorMilesValueDollar(jsonData.resultados[i].saldoTotal),
                                    fechaApertura: jsonData.resultados[i].fechaApertura,
                                    fechaVencimiento: jsonData.resultados[i].fechaVencimiento,
                                    etiqueta:jsonData.resultados[i].etiqueta,
                                    numeroLegajo:jsonData.resultados[i].numeroLegajo,
                                    tipoAhorro:jsonData.resultados[i].tipoAhorro
                                });
                            } else {
                                plazo.push({
                                    cuenta: jsonData.resultados[i].cuenta,
                                    descripcion: jsonData.resultados[i].descripcion,
                                    saldoTotal: formatoSeparadorMilesValue(jsonData.resultados[i].saldoTotal),
                                    fechaApertura: jsonData.resultados[i].fechaApertura,
                                    fechaVencimiento: jsonData.resultados[i].fechaVencimiento,
                                    etiqueta:jsonData.resultados[i].etiqueta,
                                    numeroLegajo:jsonData.resultados[i].numeroLegajo,
                                    tipoAhorro:jsonData.resultados[i].tipoAhorro

                                });
                            }

                        }
                        this.setState({ plazoFijo: plazo });
                    }
                    else {
                        if (jsonData.codigo > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            return;
                        }
                    }
                }
                ).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                }));
        return plazo;
    }

    cargarTarjetas = () => {

        var tc = [];
        if (this.openTarjeta == true) {
            this.openTarjeta = false;
            return;
        }
        this.openTarjeta = true;

        trackPromise(
            ResumenServices.getTarjetas("WEB")
                .then((response) => {

                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    //  console.log(jsonData)
                    if (jsonData.codigoRetorno === "0") {

                        for (var i = 0; i < jsonData.resultado.length; i++) {
                            var nro = jsonData.resultado[i].nroTarjeta;
                            var identificador = nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length)
                            tc.push({
                                tipo: jsonData.resultado[i].tipo,
                                nroTarjeta: identificador,
                                fechaVencPagoMin: jsonData.resultado[i].fechaVencPagoMin,
                                pagoMinimo: formatoSeparadorMilesValue(jsonData.resultado[i].pagoMinimo),
                                linea: formatoSeparadorMilesValue(jsonData.resultado[i].linea),
                                saldoNormal: separadorPuntoMiles(jsonData.resultado[i].saldoNormal),
                                saldoPlan: formatoSeparadorMilesValue(jsonData.resultado[i].saldoPlan),
                                deudaTotal: separadorPuntoMiles(jsonData.resultado[i].deudaTotal),
                                saldoMora: formatoSeparadorMilesValue(jsonData.resultado[i].saldoMora),
                                diasMora: jsonData.resultado[i].diasMora,
                                nroTC: jsonData.resultado[i].nroTarjeta,
                                tarjetaURL: this.obtenerImagenTarjeta(jsonData.resultado[i].nroTarjeta),
                                disponible: formatoSeparadorMilesValue(jsonData.resultado[i].disponible),
                                sobregiro: formatoSeparadorMilesValue(jsonData.resultado[i].sobregiro),
                                dispMasSobregiro: formatoSeparadorMilesValue(jsonData.resultado[i].dispMasSobregiro),
                                servicioCabal: jsonData.servicioCabal,
                                cuenta: jsonData.resultado[i].cuenta,
                                tarjetasAdicionales: jsonData.resultado[i].tarjetasAdicionales,
                                sucursal: jsonData.resultado[i].sucursal
                            });
                        }
                        //console.log(aportes)
                        this.setState({ tarjetas: tc });
                    }
                    else {
                        if (jsonData.codigoRetorno > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            this.setState({ mensajeSinTarjetas: "no hay registros para mostrar" });
                            return;
                        }
                    }
                }

                ).catch(function (error) {
                    //console.log(error)
                    this.setState({ mensajeSinTarjetas: "no hay registros para mostrar" });
                    authService.logout()
                })
        );
        return tc;
    }

    PrestamoPreaprobadoBanner = () => {
        var lineaCredito = [];

        trackPromise(
            PrestamoPreaprobadoServices.getLineaCredito().then((response) => {

                var data = JSON.stringify(response.data);
                var jsonData = JSON.parse(data);
                if (jsonData.codigoRetorno === "0") {
                    lineaCredito.push({
                        totalLinea: jsonData.datos.totalLinea,
                        totalUtilizado: jsonData.datos.totalUtilizado,
                        saldoLinea: jsonData.datos.saldoLinea,
                        idLinea: jsonData.datos.idLinea,
                        califica: jsonData.datos.califica,
                        maximoDisponible: jsonData.datos.totalLinea
                    });
                      this.obtenerAutorizador (jsonData.datos.idLinea); 
               
                    /*lineaCredito.push({
                        "totalLinea": 500000000,
                       "totalUtilizado": 5000,
                       "saldoLinea": 500000,
                       "idLinea": 103576,
                       "califica": "S"
                        })
*/

                    if (lineaCredito[0].califica === 'S' && lineaCredito[0].saldoLinea >= 500000) {

                        this.setState({ mostrarPrestamoInmediato: true });

                    }

                    this.setState({ prestamoInmediato: lineaCredito });
                    this.setState({ prestamoPreaprobado: lineaCredito });
                    
                }
            }).catch(function (error) {
                authService.logout();
            })
        );
    }
   obtenerAutorizador = (idLinea) => {
  const socioStr = sessionStorage.getItem("socio");
  const socio = socioStr ? JSON.parse(socioStr) : null;
  if (!socio) return;

  trackPromise(
    PrestamoPreaprobadoServices.getAutorizadorPrestamoInmediato(idLinea, socio.numeroSocio)
      .then((response) => {
        // response.data probablemente ya es un objeto
        const jsonData = response.data;
        console.log('respuesta autorizador raw', jsonData);

        if (jsonData && jsonData.codigoRetorno === "0") {
          // normalizamos exacto: string, trim y mayúscula
          const valor = String(jsonData.datos?.tieneDescSalario || '').trim().toUpperCase();

          // guardamos en state y en sessionStorage de forma segura
          this.setState({ autorizador: valor }, () => {
            // escribimos el valor explícito (NO this.state.autorizador sin callback)
            sessionStorage.setItem("autorizador", valor);

            // disparar evento custom para la misma pestaña (otros componentes lo escuchan)
            window.dispatchEvent(new CustomEvent('autorizadorChange', { detail: valor }));
          });

          console.log('dato autorizador normalizado:', valor);
        }
      })
      .catch((error) => {
        console.error('error obtenerAutorizador', error);
        authService.logout();
      })
  );
}


    // Mastercard Clásica: Todas las tarjetas que empiezan con 5150 o 5418
    // Mastercard Oro: Todas las tarjetas que empiezan con 5358 o 5402
    // Panal: Todas las tarjetas que empiezan con 6020
    // Cabal: Todas las tarjetas que empiezan con 5896 o 6042
    obtenerImagenTarjeta(nroTarjeta) {
        var prefijo = nroTarjeta.substring(0, 4);
        if (prefijo === "5150" || prefijo === "5418") {
            return "dist/img/credit/master-clasica.png";
        }
        if (prefijo === "5358" || prefijo === "5402") {
            return "dist/img/credit/master-oro.png";
        }
        if (prefijo === "6020") {
            return "dist/img/credit/panal.png";
        }
        if (prefijo === "5896" || prefijo === "6042") {
            return "dist/img/credit/cabal.png";
        }
    }

    cargarPrestamos = () => {
        var prestamo = [];
        if (this.openPrestamo === true) {
            this.openPrestamo = false;
            return;
        }
        this.openPrestamo = true;

        let pathOficialCuenta = ConfigService.getPathByName("mensajeOficialCuenta");

        if (pathOficialCuenta) {
            trackPromise(
                obtenerDatosOficialCuenta().then(response => {
                    if (response.data.codigo === 0) {
                        let datosOficialCuenta = response.data.datos;
                        datosOficialCuenta.email = datosOficialCuenta && datosOficialCuenta.email.toLowerCase();
                        this.setState({ datosOficialCuenta });
                    }
                })
            )
        }

        trackPromise(
            ResumenServices.getPrestamos("WEB")
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    //console.log(jsonData)
                    if (jsonData.codRespuesta === "0") {

                        for (var i = 0; i < jsonData.detalles.length; i++) {
                            prestamo.push({
                                cuenta: jsonData.detalles[i].cuenta,
                                descripcion: (jsonData.detalles[i].numeroDestino !== 86) ? jsonData.detalles[i].descripcion : "Préstamo Digital",
                                moneda: jsonData.detalles[i].moneda,
                                inicio: jsonData.detalles[i].inicio,
                                capital: formatoSeparadorMilesValue(jsonData.detalles[i].capital),
                                saldoCapital: formatoSeparadorMilesValue(jsonData.detalles[i].saldoCapital),
                                amortizado: formatoSeparadorMilesValue(jsonData.detalles[i].amortizado),
                                cuotasPagadas: jsonData.detalles[i].cuotasPagadas + "/" + jsonData.detalles[i].plazoCuotas,
                                fechaVencimiento: jsonData.detalles[i].fechaVencimiento,
                                ultimoPago: jsonData.detalles[i].ultimoPago,
                                alDia: jsonData.detalles[i].alDia,
                                numeroDestino: jsonData.detalles[i].numeroDestino,
                                idSolicitud: jsonData.detalles[i].idSolicitud
                            });
                        }
                        this.setState({ prestamos: prestamo });
                    }
                    else {
                        if (jsonData.codRespuesta > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            return;
                        }
                    }
                }
                ).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                }));
        return prestamo;
    }

    cargarPrestamosSolicitados = () => {
        var prestamo = [];
        trackPromise(
            ResumenServices.getPrestamosSolicitados("WEB")
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    // console.log(jsonData)
                    if (jsonData.codigo === "0") {

                        for (var i = 0; i < jsonData.resultado.length; i++) {
                            var detalle = []
                            if (jsonData.resultado[i].detalles !== null)
                                detalle = jsonData.resultado[i].detalles
                            prestamo.push({
                                numeroContrasena: jsonData.resultado[i].numeroContrasena,
                                fechaContrasena: jsonData.resultado[i].fechaContrasena,
                                montoSolicitado: formatoSeparadorMilesValue(jsonData.resultado[i].montoSolicitado),
                                solicitud: jsonData.resultado[i].solicitud,
                                sucursal: jsonData.resultado[i].sucursal,
                                fechaSolicitud: jsonData.resultado[i].fechaSolicitud,
                                oficial: jsonData.resultado[i].oficial,
                                detalle: detalle
                            });
                        }
                        this.setState({ solicitudPrestamos: prestamo });
                    }
                    else {

                        if (jsonData.codigo > 0) {
                            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
                            return;
                        }
                    }
                }
                ).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                }));
        return prestamo;
    }

    formatearFechaVencimiento(fechaStr) {
        if (!fechaStr) return '';
        const [fecha] = fechaStr.split(' ');
        const [anio, mes, dia] = fecha.split('-');
        return `${dia}/${mes}/${anio}`;
    }

    modificacionFechaVencimientoPrestamos = () => {
        const payLoad = {
            idPersona : authService.getSocio().idPersona,
            canal : 'WEB'
        }
        trackPromise(
            ResumenServices.getPrestamosCuotasEditables(payLoad)
            .then( (response) => {
                const { codigoRetorno , mensajeRespuesta, detalles } = JSON.parse(JSON.stringify(response.data));
                // console.log({codigoRetorno,mensajeRespuesta,detalles});
                if( codigoRetorno !== '0' ){
                    this.notifiPopup('Info',mensajeRespuesta ? mensajeRespuesta : 'Ha ocurrido algún error al listar los créditos.');
                    return;
                }
                const data = [];
                if( detalles.length >= 1 )
                    detalles.forEach( (elem) => {
                        data.push({
                            cuenta: elem.cuenta,
                            descripcion: (elem.numeroDestino !== 86) ? elem.descripcion : "Préstamo Digital",
                            moneda: elem.moneda,
                            inicio: elem.inicio,
                            capital: formatoSeparadorMilesValue(elem.capital),
                            saldoCapital: formatoSeparadorMilesValue(elem.saldoCapital),
                            amortizado: formatoSeparadorMilesValue(elem.amortizado),
                            cuotasPagadas: elem.cuotasPagadas,
                            fechaVencimiento: this.formatearFechaVencimiento(elem.fechaVencimiento),
                            ultimoPago: elem.ultimoPago,
                            numeroDestino: elem.numeroDestino,
                            idSolicitud: elem.idSolicitud
                        });
                    });
                this.setState({prestamosCuotaModificable : data});
            })
            .catch( err =>{
                console.error(err);
            })
        )
    }

    cargarSolicitudesSubsidios = () => {
        let respuesta = [];

        if (this.openSubsidio == true) {
            this.openSubsidio = false;
            return;
        }
        this.openSubsidio = true;
        trackPromise(
            ResumenServices.getSolicitudesSubsidios()
                .then((response) => {
                    let data = JSON.stringify(response.data);
                    let jsonData = JSON.parse(data);
                    //console.log(jsonData)
                    if (jsonData.codigo === 0) {
                        // let indice = 0;
                        for (let i = 0; i < jsonData.datos.length; i++) {
                            respuesta.push({
                                nroSolicitud: jsonData.datos[i].identificador,
                                cuentaAhorro: jsonData.datos[i].idAhorro,
                                tipoSubsidio: jsonData.datos[i].tipoSubsidioDescripcion,
                                claseSubsidio: jsonData.datos[i].claseSubsidioDescripcion,
                                idClaseSubsidio: jsonData.datos[i].claseSubsidio,
                                fechaHecho: jsonData.datos[i].fechaHecho,
                                fechaPresentacion: (jsonData.datos[i].fechaPresentacion !== null) ? jsonData.datos[i].fechaPresentacion : "----",
                                estado: jsonData.datos[i].estadoDescripcion,
                                estadoID: jsonData.datos[i].estado,
                            });
                        }
                        this.setState({ subsidios: respuesta });
                    }
                    else {
                        Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
                        return;
                    }
                }).catch(function (error) {
                    //console.log(error)
                    authService.logout()
                }));
        return respuesta;
    }



    avisoDimo = () => {
        var titulo = "INFO";
        var mensaje = "¿Desea enlazar la Universitaria Ltda. a la aplicación Dimo para realizar operaciones?"
        Popup.queue(
            this.notifiPopupDimo(titulo, mensaje)
        );
    }


    invocarVinculacionDimo = () => {
        trackPromise(
            DimoService.vincularSocioDimo("WEB")
                .then((response) => {
                    var data = JSON.stringify(response.data);
                    var jsonData = JSON.parse(data);
                    if (jsonData.codReturn === 0) {
                        Popup.queue(this.notifiPopup("Info", jsonData.txtReturn));
                    }
                    else {
                        Popup.queue(this.notifiPopup("Info", jsonData.txtReturn));
                        //return;

                    }
                }

                ).catch(function (error) {
                    console.log("el error es:", error);
                    //authService.logout()
                })
        );
    }

    notifiPopupDimo = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: () => {
                            this.invocarVinculacionDimo();
                            Popup.close();
                        },
                    },
                    {
                        text: "Cerrar",
                        className: "secundary",
                        action: function () {
                            Popup.close();
                        },
                    }
                ],
            },
        });

    notifiPopupAsamblea = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Confirmar",
                        className: "success",
                        action: () => {
                            this.registroAsamblea();
                            Popup.close();
                        },
                    },
                    {
                        text: "Cerrar",
                        className: "secundary",
                        action: function () {
                            Popup.close();
                        },
                    }
                ],
            },
        });

    notifiPopup = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });


    descargar = async () => {
        await trackPromise(
            ResumenServices.descagarExtractoGeneral()
                .then((response) => {
                    var fileURL = URL.createObjectURL(response.data);
                    window.open(fileURL, "");
                })
                .catch(function (error) {
                    console.log(error);
                })
        );
    };

    registroAsamblea = () => {
        console.log("registro asamblea");
    }

    mostrarDatosTransferencia = ({ nombre, cedula, cuenta }) => {
        return (

            <div className="card card-datos-transferencia">
                <div className="card-body" >
                    <div className="row">
                        <div className="col-7">
                            <img src="dist/img/Logo_CU_Verde.png" width="150px" alt="" />
                        </div>
                        <div className="col-5 d-flex">
                            <img src="dist/img/logo_bcp.png" width="85px" alt=""
                                style={{ position: "relative", top: "-10px" }}
                            />
                            <p className="float-right card-text">Transferencias por SIPAP</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <p className="card-title">Para Transferir a:</p>
                            <p className="card-text">{nombre}</p>
                        </div>
                    </div>
                    <div className="row" style={{ height: "5rem" }}>
                        <div className="col-4">
                            <p className="card-title">N° Cédula</p>
                            <p className="card-text">{cedula}</p>
                        </div>
                        <div className="col-4">
                            <p className="card-title">Banco</p>
                            <img className="card-text" src="dist/img/logo_basa.png" width="120px" alt=""
                                style={{ position: "relative", top: "-50px" }}
                            />
                        </div>
                        <div className="col-4">
                            <p className="card-title">Cuenta</p>
                            <p className="card-text">{cuenta}</p>
                        </div>
                    </div>
                </div>
            </div >
        )
    }

    /**
     * @description esta variable, guarda las funciones a ejecutar segun sea el path
     */
    funciones = {
        ahorros: {
            resumenAhorrosVista: this.cargarAHVista,
            resumenAhorrosProgramados: this.cargarAhorroProgramado,
            resumenAhorrosRueda: this.cargarRuedas,
            resumenAhorrosPlazoFijo: this.cargarPlazoFijo
        },
        obligaciones: {
            resumenObligacionesAporte: this.cargarAporte,
            resumenObligacionesSolidaridad: this.cargarSolidaridad,
            resumenObligacionesSepelio: this.cargarPagareSepelio
        },
        prestamos: {
            resumenPrestamosActivos: this.cargarPrestamos,
            resumenPrestamosSolicitudes: this.cargarPrestamosSolicitados,
            modificacionFechaVencimiento: this.modificacionFechaVencimientoPrestamos
        },
        tarjetas: {
            resumenTarjetas: this.cargarTarjetas
        },
        subsidios: {
            resumenSubsidios: this.cargarSolicitudesSubsidios
        }
    }

    obtenerAviso = () => {

        let pathAviso = ConfigService.getPathByName("resumenAvisos");
        if (!pathAviso) return false;

        let ocultarAviso = sessionStorage.getItem("ocultarAviso")
        if (ocultarAviso === "S") return false;

        trackPromise(
            ConfigService.obtenerAviso().then(response => {
                let { codigoRetorno, datos } = response.data;

                if (codigoRetorno === "0") {
                    if (datos?.mostrar === true) {
                        if (datos?.titulo === "IMAGEN-NO-TOKEN") {
                            if (sessionStorage.getItem('tieneToken') === 'N') {
                                this.obtenerImgAviso();
                            }
                        } else {
                            notify(datos?.mensaje)
                        }
                        sessionStorage.setItem("ocultarAviso", 'S')
                    }
                }
            }).catch(error => console.log(error)),

        )
    }

    obtenerImgAviso() {
        trackPromise(
            ConfigService.obtenerAviso().then(response => {
                let { codigoRetorno, datos } = response.data;

                if (codigoRetorno === "0") {
                    if (datos?.titulo === 'IMAGEN-NO-TOKEN') {
                        if (sessionStorage.getItem('tieneToken') === 'N') {
                            // console.log("datosNoti", datos.titulo);
                            Popup.queue(this.notifiPopupAvisoImg(datos?.titulo, datos?.mensaje));
                            sessionStorage.setItem("mostrarAviso", 's');
                        }
                    }

                }
            }).catch(error => console.log(error)),
        )
    }

    notifiPopupAvisoImg = (titulo, img) =>
        Popup.register({

            title: "Aviso",
            className: 'popover  itemNoti',
            content:

                <div className="popup imgavisoimg">
                    <div className="page">
                        <div className="navbar">
                            <div className="navbar-inner">
                                <div className="title"><img src={img} alt={"logo"} width={'100%'} /> </div>
                            </div>
                        </div>
                    </div>
                </div>,
            buttons: {
                right: [
                    {
                        text: "Ok",
                        className: "secundary",
                        action: function () {
                            sessionStorage.setItem('mostrarAviso', true);
                            Popup.close();
                        },
                    },

                ],
            },
        });
    render() {

        // console.log(`render resumen...`)

        return (

            <div className="content-wrapper">

                <Titulo texto="Resumen de Cuentas" />
                <AvisoSocio />



                {/* <section className="content-header socio-excelencia">
                    <div className="container">
                        <div className="row">
                            <div className="col-2 col-2-60">
                                <img src="dist/img/success.png" width="50" />
                            </div>
                            <div className="col-10">
                                <h5 style={{color: "#525252",marginBottom: 0}}>
                                    El socio califica para Crédito a la EXCELENCIA.
                                </h5>
                                <span>Sujeto a análisis y/o utilización de línea de crédito</span>
                            </div>
                        </div>
                    </div>
                </section> */}

                <section className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 mb-3" style={ConfigService.ocultarSegunNombre("resumenAsamblea")}>
                                <div className="row m-0 p-3 rounded agendar-box">
                                    <div className="col-md-9 d-flex">
                                        <p className="m-md-auto text-center agendar">
                                            Agendamiento Obligatorio p/ asistir a la Asamblea Deliberativa (Res. 25.079/22 INCOOP)
                                        </p>
                                    </div>

                                    <div className="col-md-3 d-flex">
                                        <button className="btn btn-cu-largo-secundary"
                                            type="button"
                                            data-toggle="modal"
                                            data-target="#modal-inscripcion">
                                            <FontAwesomeIcon icon={faArrowRight} /> Ingrese aquí
                                        </button>
                                    </div>
                                    <PopupInscripcionAsamblea />
                                </div>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 col-12"></div>
                                    <div className="col-lg-3 col-md-6 col-12" style={ConfigService.ocultarSegunNombre("resumenDimo")}>
                                        <button className="btn btn-cu-secundary-apagado btn-block btn-consulta" onClick={this.avisoDimo}>
                                            <img src="dist/img/dimo-blanco.png" className="mx-auto" width="80" alt="logo-dimo" />
                                        </button>

                                    </div>
                                    <div className="col-lg-3 col-md-6 col-12" style={ConfigService.ocultarSegunNombre("resumenDescargaExtracto")}>
                                        <div >
                                            <button
                                                data-toggle="modal"
                                                data-target="#modal-pin-extracto"
                                                className="btn btn-cu-apagado btn-block"

                                            >
                                                <FontAwesomeIcon icon={faDownload} />  Descargar Extracto
                                            </button>
                                            <ModalPinTransaccional id="modal-pin-extracto" onSuccess={this.descargar} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <Cotizacion ref={this.refCotizacion} cotizacion={this.state.cotizaciones} />
                            </div> */}
                            <div className="col-md-12"></div>
                        </div>
                        <br />

                        <div className="row d-flex align-items-center">
                            <div className={Object.keys(this.state.lineaTarjeta).length > 0
                                ? "col-lg-6 col-md-12 col-sm-12 mb-3"
                                : "col-md-12 col-sm-12 mb-3"}>
                                {
                                    (!this.state.mostrarPrestamoInmediato && this.state.prestamoPreaprobado.length > 0 && this.state.prestamoPreaprobado[0].saldoLinea >= 500000) &&
                                    <PrestamoPreaprobadoBanner ref={this.refPreaprobado} preaprobado={this.state.prestamoPreaprobado} />
                                }
                            </div>
                            <div className={Object.keys(this.state.lineaTarjeta).length > 0
                                ? "col-lg-6 col-md-12 col-sm-12 mb-3"
                                : "col-md-12 col-sm-12 mb-3"}>
                                {
                                    (this.state.mostrarPrestamoInmediato) &&
                                    <PrestamoInmediatoBanner ref={this.refPreaprobado}   inmediato={this.state.prestamoInmediato}
  autorizador={this.state.autorizador}
    />
                                }
                            </div>

                        </div>

                        <div className="row">

                            <div className="col-md-12 col-resumen" style={ConfigService.ocultarSegunNombre("resumenAhorros")}>
                                <div className="card  collapsed-card" style={{ boxShadow: "none" }}>
                                    <div className="card-header card-header-resumen px-3 button-image-ahorro zoom">
                                        <button onClick={this.funciones.ahorros[ConfigService.getFirstChildByName("resumenAhorros")?.nombre]} className="card-tools card-tools-tab float-left btn btn-block px-0 px-sm-2 btn-expansible-resumen" data-card-widget="collapse" style={{ textAlign: "inherit" }}>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-9 col-10">
                                                    <h3 className="texto-resumen">
                                                        <img className="icono-resumen" src="dist/img/icono-ahorro.png" width={70}>
                                                        </img>  Ahorros</h3>
                                                </div>

                                                <div className="col-lg-6 col-md-3 col-2">
                                                    <i className="fas fa-plus float-right plus-resumen" />
                                                </div>
                                            </div>

                                        </button>
                                    </div>
                                    <div className="card-body pad table-responsive card-body-tab">

                                        <div className="card card-tab">
                                            <div className="card-header p-2 card-header-tab">
                                                <ul className="nav nav-pills">

                                                    <AuxNavItem
                                                        name="resumenAhorrosVista"
                                                        href="#ahorroVista"
                                                        onClick={this.funciones.ahorros["resumenAhorrosVista"]}
                                                    >
                                                        <FontAwesomeIcon icon={faPiggyBank} />   Ahorros a la Vista
                                                    </AuxNavItem>

                                                    <AuxNavItem
                                                        name="resumenAhorrosProgramados"
                                                        href="#ahorroProgramado"
                                                        onClick={this.funciones.ahorros["resumenAhorrosProgramados"]}
                                                    >
                                                        <FontAwesomeIcon icon={faCircleDollarToSlot} />    Ahorros Programados
                                                    </AuxNavItem>

                                                    <AuxNavItem
                                                        name="resumenAhorrosRueda"
                                                        href="#rueda"
                                                        onClick={this.funciones.ahorros["resumenAhorrosRueda"]}
                                                    >
                                                        <FontAwesomeIcon icon={faCircleDot} />  Rueda Gigante
                                                    </AuxNavItem>

                                                    <AuxNavItem
                                                        name="resumenAhorrosPlazoFijo"
                                                        href="#plazoFijo"
                                                        onClick={this.funciones.ahorros["resumenAhorrosPlazoFijo"]}
                                                    >
                                                        <FontAwesomeIcon icon={faHandHoldingDollar} />   Plazos Fijos
                                                    </AuxNavItem>

                                                </ul>
                                            </div>
                                            {/* /.card-header */}
                                            <div className="card-body" style={{ padding: 0 }} >
                                                <div className="tab-content">

                                                    <TabPane name="resumenAhorrosVista" id="ahorroVista">
                                                        <AHVista ref={this.refAHVista} ahorros={this.state.ahorros} />
                                                    </TabPane>

                                                    <TabPane name="resumenAhorrosProgramados" id="ahorroProgramado">
                                                        <AhorroProgramado ref={this.refAhorroProgramado} ahorroProgramado={this.state.ahorroProgramado} />
                                                    </TabPane>

                                                    <TabPane name="resumenAhorrosRueda" id="rueda">
                                                        <Rueda ref={this.refRueda} ruedaSocio={this.state.ruedas} />
                                                    </TabPane>

                                                    <TabPane name="resumenAhorrosPlazoFijo" id="plazoFijo">
                                                        <PlazoFijo ref={this.refPlazoFijo} plazoFijo={this.state.plazoFijo} />
                                                    </TabPane>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 col-resumen" style={ConfigService.ocultarSegunNombre("resumenObligaciones")}>
                                <div className="card collapsed-card" style={{ boxShadow: "none" }}>

                                    <div className="card-header card-header-resumen px-3 button-image-compromiso">
                                        <button onClick={this.funciones.obligaciones[ConfigService.getFirstChildByName("resumenObligaciones")?.nombre]} className="card-tools card-tools-tab float-left btn btn-block px-0 px-sm-2 btn-expansible-resumen" data-card-widget="collapse" style={{ textAlign: "inherit" }}>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-9 col-10">
                                                    <h3 className="texto-resumen"> <img className="icono-resumen" src="dist/img/icono-compromiso.png" width={70}></img>  Compromiso</h3>
                                                </div>

                                                <div className="col-lg-6 col-md-3 col-2">
                                                    <i className="fas fa-plus float-right plus-resumen" />
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                    <div className="card-body pad table-responsive card-body-tab">
                                        <div className="card card-tab">
                                            <div className="card-header p-2 card-header-tab">
                                                <ul className="nav nav-pills">

                                                    <AuxNavItem
                                                        name="resumenObligacionesAporte"
                                                        href="#aporte"
                                                        onClick={this.funciones.obligaciones["resumenObligacionesAporte"]}
                                                    >
                                                        <FontAwesomeIcon icon={faCoins} />    Aporte
                                                    </AuxNavItem>

                                                    <AuxNavItem
                                                        name="resumenObligacionesSolidaridad"
                                                        href="#solidaridad"
                                                        onClick={this.funciones.obligaciones["resumenObligacionesSolidaridad"]}
                                                    >
                                                        <FontAwesomeIcon icon={faHandshake} />   Solidaridad
                                                    </AuxNavItem>

                                                    <AuxNavItem
                                                        name="resumenObligacionesSepelio"
                                                        href="#sepelio"
                                                        onClick={this.funciones.obligaciones["resumenObligacionesSepelio"]}


                                                    >
                                                        <FontAwesomeIcon icon={faDove} />    Sepelios
                                                    </AuxNavItem>

                                                </ul>
                                            </div>
                                            {/* /.card-header */}
                                            <div className="card-body">
                                                <div className="tab-content">
                                                    <TabPane name="resumenObligacionesAporte" id="aporte">
                                                        <Aporte ref={this.refAporte} aporte={this.state.aportes} detalle={this.state.detalleAporte} />
                                                    </TabPane>

                                                    <TabPane name="resumenObligacionesSolidaridad" id="solidaridad">
                                                        <Solidaridad ref={this.refSolidaridad} solidaridad={this.state.solidaridad} detalle={this.state.detalleSolidaridad} />
                                                    </TabPane>

                                                    <TabPane name="resumenObligacionesSepelio" id="sepelio">
                                                        <Sepelio data={this.state.detallePagareSepelio} />
                                                    </TabPane>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12 col-resumen" style={ConfigService.ocultarSegunNombre("resumenPrestamos")}>
                                <div className="card collapsed-card" style={{ boxShadow: "none" }}>
                                    <div className="card-header card-header-resumen px-3 button-image-prestamo">
                                        <button onClick={this.funciones.prestamos[ConfigService.getFirstChildByName("resumenPrestamos")?.nombre]} className="card-tools card-tools-tab float-left btn btn-block px-0 px-sm-2 btn-expansible-resumen" data-card-widget="collapse" style={{ textAlign: "inherit" }}>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-9 col-10">
                                                    <h3 className="texto-resumen">
                                                        <img className="icono-resumen" src="dist/img/icono-prestamo.png" width={70}></img>  Préstamos</h3>
                                                </div>

                                                <div className="col-lg-6 col-md-3 col-2">
                                                    <i className="fas fa-plus float-right plus-resumen" />
                                                </div>
                                            </div>
                                        </button>
                                    </div>

                                    <div className="card-body pad table-responsive card-body-tab">
                                        <div className="card card-tab">
                                            {(this.state.prestamoPreaprobado.length > 0 && this.state.prestamoPreaprobado[0].califica === 'S') &&

                                                <div className={Object.keys(this.state.lineaTarjeta).length > 0
                                                    ? "col-lg-6 col-md-12 col-sm-12 mb-1"
                                                    : "col-md-12 col-sm-12 mb-1"}>

                                                    {this.state.mostrarPrestamoInmediato &&
                                                        <div className="card banner-preaprobado-Pi" style={{ margin: "1rem" }}>
                                                            <div className="card-body-Pi" style={{ padding: "0.9rem" }}>
                                                                <div className="row">
                                                                    <div className="col-md-12 col-descripcion">

                                                                        <div className="row">

                                                                            <div className="col-md-9">

                                                                                <h5 className="texto-credito">Desembolsá tu <strong>Préstamo Digital</strong> hasta <span className="texto-credito-Pi">{formatoSeparadorMilesValue(this.state.prestamoInmediato[0].saldoLinea)} gs</span> </h5>

                                                                            </div>
                                                                            <div className="col-md-3" >
                                                                                <button className="btn btn-ingresar-Pi btn-block m-auto" onClick={this.prestamoInmediato}>
                                                                                    <FontAwesomeIcon icon={faHand} color="#EAAC24" /> Quiero
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    }

                                                </div>
                                            }
                                            <div className="card-header p-2 card-header-tab">
                                                <ul className="nav nav-pills">

                                                    <AuxNavItem
                                                        name="resumenPrestamosActivos"
                                                        href="#prestamosActivos"
                                                        onClick={this.funciones.prestamos["resumenPrestamosActivos"]}
                                                    >
                                                        <FontAwesomeIcon icon={faMoneyCheckDollar} />    Préstamos Activos
                                                    </AuxNavItem>

                                                    <AuxNavItem
                                                        name="resumenPrestamosSolicitudes"
                                                        href="#prestamosSolicitados"
                                                        onClick={this.funciones.prestamos.resumenPrestamosSolicitudes}
                                                    >
                                                        <FontAwesomeIcon icon={faClipboardCheck} />   Solicitudes
                                                    </AuxNavItem>

                                                    <AuxNavItem
                                                        name="modificacionFechaVencimiento"
                                                        href="#modificacionFechaVencPrestamo"
                                                        onClick={this.funciones.prestamos.modificacionFechaVencimiento}
                                                    >
                                                        <FontAwesomeIcon icon={faClipboardCheck} />   Modificar Fecha Vencimiento
                                                        {/* <FontAwesomeIcon icon={faPenToSquare} />Modificar Fecha Vencimiento */}
                                                    </AuxNavItem>


                                                </ul>
                                            </div>
                                            {/* /.card-header */}
                                            <div className="card-body" style={{ padding: 0 }}>
                                                <div className="tab-content">

                                                    <TabPane name="resumenPrestamosActivos" id="prestamosActivos">
                                                        <Prestamos ref={this.refPrestamos} prestamos={this.state.prestamos} />
                                                        <br />
                                                        <AvisoPrestamo prestamos={this.state.prestamos} />
                                                        {this.state.datosOficialCuenta && ConfigService.getPathByName("mensajeOficialCuenta") &&
                                                            <div className="col-12 my-1">
                                                                <div className="row p-2 text-dark agendar-box">
                                                                    <div className="col-12">
                                                                        <h6>Oficial de Cuentas</h6>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-8 col-lg-7 justify-content-center">
                                                                        <p className="m-0 text-left oficial"><span>Nombre:</span> {this.state.datosOficialCuenta.nombreCompleto}</p>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4 col-lg-5 justify-content-center">
                                                                        <p className="m-0 text-left oficial"><span>Teléfono:</span> {this.state.datosOficialCuenta.celular}</p>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-8 col-lg-7 justify-content-center">
                                                                        <p className="m-0 text-left oficial"><span>E-mail:</span> {this.state.datosOficialCuenta.email}</p>
                                                                    </div>
                                                                    <div className="col-sm-12 col-md-4 col-lg-5 justify-content-center">
                                                                        <p className="m-0 text-left oficial"><span>Sucursal:</span> {this.state.datosOficialCuenta.sucursal}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </TabPane>

                                                    <TabPane name="resumenPrestamosSolicitudes" id="prestamosSolicitados">
                                                        <SolicitudesPrestamo ref={this.refSolPrestamo} prestamos={this.state.solicitudPrestamos} />
                                                    </TabPane>

                                                    <TabPane name="modificacionFechaVencimiento" id="modificacionFechaVencPrestamo">
                                                        <ModificacionFechaVencPrestamo detalles={this.state.prestamosCuotaModificable} />
                                                    </TabPane>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* */}
                            <div className="col-md-12 col-resumen" style={ConfigService.ocultarSegunNombre("resumenTarjetas")}>
                                <div className="card collapsed-card" style={{ boxShadow: "none" }}>
                                    <div className="card-header card-header-resumen px-3 button-image-tarjeta">
                                        <button onClick={this.funciones.tarjetas["resumenTarjetas"]} className="card-tools card-tools-tab float-left btn btn-block btn-expansible-resumen px-0 px-sm-2" data-card-widget="collapse" style={{ textAlign: "inherit" }}>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-9 col-10">
                                                    <h3 className="texto-resumen">
                                                        <img className="icono-resumen" src="dist/img/icono-tarjeta.png" width={70}>
                                                        </img>  Tarjetas</h3>
                                                </div>

                                                <div className="col-lg-6 col-md-3 col-2">
                                                    <i className="fas fa-plus float-right plus-resumen" />
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                    <div className="card-body pad table-responsive card-body-tab">
                                        <div className="tab-content">
                                            <div className="active tab-pane table-responsive" id="tarjetaCredito">
                                                <Tarjetas
                                                    ref={this.refTC}
                                                    tc={this.state.tarjetas}
                                                    mensajeSinTarjetas={this.state.mensajeSinTarjetas}
                                                />
                                            </div>

                                            {/* /.tab-pane */}
                                        </div>
                                        {/* /.tab-content */}
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12" style={ConfigService.ocultarSegunNombre("resumenSubsidios")}>
                                <div className="card collapsed-card" style={{ boxShadow: "none" }}>
                                    <div className="card-header card-header-resumen px-3 button-image-subsidio" >
                                        <button onClick={this.funciones.subsidios['resumenSubsidios']} className="card-tools card-tools-tab float-left btn btn-block btn-expansible-resumen px-0 px-sm-2" data-card-widget="collapse">
                                            <div className="row">
                                                <div className="col-lg-6 col-md-9 col-10">
                                                    <h3 className="texto-resumen">
                                                        <img className="icono-resumen" src="dist/img/icono-subsidio.png" width={70}></img>  Subsidios</h3>
                                                </div>

                                                <div className="col-lg-6 col-md-3 col-2">
                                                    <i className="fas fa-plus float-right plus-resumen" />
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                    <div className="card-body pad table-responsive card-body-tab">
                                        <div className="tab-content">
                                            <div className="active tab-pane table-responsive card-body" id="subsidios">
                                                {/* <AvisoGeneral prestamos={this.state.subsidios} /> */}
                                                <Subsidios ref={this.refSubsidios} subsidios={this.state.subsidios}></Subsidios>
                                            </div>
                                            {/* /.tab-pane */}
                                        </div>
                                        {/* /.tab-content */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* {
                            this.state.socio !== null && this.state.socio?.username === "4462404" &&

                            <>
                                <LectorQr />
                            </>

                        } */}
                        {/* /.row */}
                        <div className="row d-flex align-items-center">

                            {/* <div className={Object.keys(this.state.lineaTarjeta).length > 0
                                ? "col-lg-6 col-md-12 col-sm-12 mb-3"
                                : "col-md-12 col-sm-12 mb-3"}>
                                {
                                    (this.state.prestamoPreaprobado.length > 0 && this.state.prestamoPreaprobado[0].saldoLinea >= 500000) &&
                                    <PrestamoPreaprobadoBanner ref={this.refPreaprobado} preaprobado={this.state.prestamoPreaprobado} />
                                }
                            </div>
                            <div className={Object.keys(this.state.lineaTarjeta).length > 0
                                ? "col-lg-6 col-md-12 col-sm-12 mb-3"
                                : "col-md-12 col-sm-12 mb-3"}>
                                {
                                    (this.state.prestamoPreaprobado.length > 0 && this.state.prestamoPreaprobado[0].saldoLinea >= 500000) &&
                                    <PrestamoInmediatoBanner ref={this.refPreaprobado} inmediato={this.state.prestamoPreaprobado} />
                                }
                            </div> */}



                            <div className={(this.state.prestamoPreaprobado.length > 0 && this.state.prestamoPreaprobado[0].saldoLinea >= 500000)
                                ? "col-lg-6 col-md-12 col-sm-12 mb-3"
                                : "col-md-12 col-sm-12 mb-3"}>
                                {
                                    Object.keys(this.state.lineaTarjeta).length > 0 &&
                                    <div>
                                        <div className="navbar-promo navbar-light row mx-2 p-2 rounded rounded-2 promo-tarjeta">
                                            <div className="col-md-9 px-2 d-flex align-items-center justify-content-left">
                                                <div className="text-center text-md-right text-lg-right">
                                                    <p className="promo-titulo text-md-nowrap" style={{ fontFamily: "Montserrat-Regular" }} >Ud.tiene una línea disponible en TC de <span style={{ fontSize: "1.5rem", fontWeight: 500, fontFamily: "Montserrat-Semibold" }}>Gs.{validarNull(this.state.lineaTarjeta.saldo)}</span></p>
                                                    <p style={{ lineHeight: "1.6rem", fontFamily: "Montserrat-Regular" }}>
                                                        {/* Promo válida desde {validarNull(this.state.lineaTarjeta.fecha)} a {validarNull(this.state.lineaTarjeta.fechaVencimiento)} */}
                                                        {/* <br /> */}
                                                        Vendedor: {validarNull(this.state.lineaTarjeta.funcionarioVendedor)}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 py-3 px-2 d-inline-flex">
                                                <button type="button" onClick={this.solicitarPrecalificado} className="btn btn-light btn-quiero btn-block m-auto"><FontAwesomeIcon icon={faHand} /> Quiero</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {/* /.container-fluid */}
                </section >
            </div >
        );
    }
}